function snakeToCamelCase(string) {
  return string.replace(/-./g, $1 => $1.replace('-', '').toUpperCase());
}

export default snakeToCamelCase;
